import { useState } from 'react';
import ButtonItem from '../../components/ButtonItem';

function YouTubeDownload() {
  const [keyWord, setKeyWord] = useState('');
  const [downloadNum, setDownloadNum] = useState('');
  const [loading, setLoading] = useState(false);

  const keyWordValueChange = (e) => setKeyWord(e.target.value);

  const downloadNumValueChange = (e) => {
    const v = e.target.value;
    setDownloadNum(v.replace(/[^0-9]/g, ''));
  };

  const handleDownload = async () => {
    const num = Number(downloadNum);
    setLoading(true);

    try {
      await fetch('http://localhost:3000/YouTubeDownload', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          keyword: keyWord.trim(),
          downloadNum: num,
        }),
      });
    } catch (error) {
      console.error(error);
      alert('다운로드 중 오류 발생');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-dvh h-dvh flex flex-col items-center overflow-y-auto p-12">
      <div className="w-full mb-10 text-3xl text-center font-bold">
        <span>유튜브 다운로드 및 생성</span>
      </div>

      <div className="w-[500px] flex flex-col justify-center space-y-6">
        <div className="w-full">
          <label className="block text-lg font-semibold mb-1">
            검색 키워드
          </label>
          <input
            type="text"
            value={keyWord}
            onChange={keyWordValueChange}
            className="w-full h-12 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
            placeholder="예) 고양이 쇼츠"
          />
        </div>

        <div className="w-full">
          <label className="block text-lg font-semibold mb-1">생성 개수</label>
          <input
            type="number"
            value={downloadNum}
            onChange={downloadNumValueChange}
            className="w-full h-12 px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
            placeholder="예) 2"
          />
        </div>

        <div className="w-full pt-6">
          <ButtonItem
            text={loading ? '다운로드 중...' : '영상 다운로드'}
            color="blue"
            className="w-full h-14 rounded-xl text-xl"
            onClick={handleDownload}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
}

export default YouTubeDownload;
